import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  Button,
  Form,
  Modal,

} from "@themesberg/react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCog, faPlus, faDownload } from "@fortawesome/free-solid-svg-icons";

import Layout from "../../components/Layout";
import CardWithChart from "../../components/StateOverview/RefugeCard";
import ShelterLossChart from "../../components/StateOverview/ShelterLossChart";
import Sheltersview from "../../components/StateOverview/Shelters";
import Availabilityview from "../../components/StateOverview/Availability";
import SheltersChart from "../../components/StateOverview/ShelterCard";
import AvailableRoomCard from "../../components/StateOverview/AvailableRoomCard";
import AvailableUsersCard from "../../components/StateOverview/AvailableUsersCard";
import GlobalShelterSettings from "../../components/StateOverview/GlobalShelterSettings";
import RegisterAdminModal from "../../components/RegisterAdminModal";

import { BASE_URL } from "../../constants";

const Dashboard = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
   const [showModal, setShowModal] = useState(false);
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationMessage, setNotificationMessage] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");
 const [show, setShow] = useState(false);
 const [showToast, setShowToast] = useState(false);
 const [toastMessage, setToastMessage] = useState("");
 const [toastVariant, setToastVariant] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/shelters`);
        setRooms(response.data);
      } catch (error) {
        console.error("Error fetching rooms data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRooms();
  }, []);

  const handleSendNotification = async () => {
    if (!notificationTitle || !notificationMessage) {
      setAlertMessage("Please fill in both fields.");
      setAlertVariant("danger");
      setShowAlert(true);
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${BASE_URL}/refugees/broadcast`,
        { message: notificationMessage, type: notificationTitle },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setAlertMessage("Notification sent successfully.");
      setAlertVariant("success");
      setShowAlert(true);
      setShowNotificationModal(false);
      setNotificationTitle("");
      setNotificationMessage("");
    } catch (error) {
      console.error("Error sending notification:", error);
      setAlertMessage("Failed to send notification.");
      setAlertVariant("danger");
      setShowAlert(true);
    }
  };
const notify = (variant, message) => {
  setToastVariant(variant);
  setToastMessage(message);
  setShowToast(true);
};
  return (
    <Layout>
   <div className="d-flex justify-content-between align-items-center mb-3">

  <Button
    variant="cyan"
    onClick={() => setShow(true)}
  >
    <FontAwesomeIcon icon={faPlus} className="me-2" />
    <span className="small">Create State/Admin</span>
  </Button>


  <div className="d-flex gap-2">
    <Button
      variant="outline-cyan"
      onClick={() => setShowSettingsModal(true)}
    >
      <FontAwesomeIcon icon={faCog} />
    </Button>

    <Button
      variant="outline-cyan"
      onClick={() => setShowModal(true)}
    >
      <FontAwesomeIcon icon={faBell} className="me-2" />
      <span className="small">Send Notification</span>
    </Button>
  </div>


  <RegisterAdminModal show={show} handleClose={() => setShow(false)} notify={notify} />
</div>



<ToastContainer position="top-end" className="p-3">
  <Toast
    bg={toastVariant}
    onClose={() => setShowToast(false)}
    show={showToast}
    delay={3000}
    autohide
  >
    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
  </Toast>
</ToastContainer>
      {/* Charts Section */}
      <Row className="mt-3">
        <Col md={3} className="mb-3 d-flex">
          <CardWithChart className="flex-fill" />
        </Col>
        <Col md={3} className="mb-3 d-flex">
          <SheltersChart className="flex-fill" />
        </Col>
        <Col md={3} className="mb-3 d-flex">
          <AvailableRoomCard className="flex-fill" />
        </Col>
        <Col md={3} className="mb-3 d-flex">
          <AvailableUsersCard className="flex-fill" />
        </Col>
      </Row>

      {/* Shelters & Availability Section */}
      <Row className="mt-3">
        <Col md={4} className="mb-3">
          <Sheltersview />
        </Col>
        <Col md={4} className="mb-3">
          <Availabilityview />
        </Col>
        <Col md={4} className="mb-3">
          <ShelterLossChart />
        </Col>
      </Row>

      {/* Notification Modal */}
  <Modal show={showModal} onHide={() => setShowModal(false)} centered contentClassName="twitter-style-modal">
  <Modal.Body className="p-6 text-center bg-white rounded-4 shadow-lg">
    <div className="mb-4">
      <div
        className="bg-primary-subtle text-primary rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{ width: 60, height: 60 }}
      >
        <i className="fas fa-bell fa-lg"></i>
      </div>
      <h5 className="fw-bold mt-3">Send Notification</h5>
    </div>

    <Form className="text-start">
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Title</Form.Label>
        <Form.Control
          type="text"
          placeholder="Notification title"
          className="rounded-3"
          value={notificationTitle}
          onChange={(e) => setNotificationTitle(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="Enter the notification content here..."
          className="rounded-3"
          value={notificationMessage}
          onChange={(e) => setNotificationMessage(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Check
          type="checkbox"
          label="Select All Users"
          className="fw-medium"
          checked={true} 
          disabled 
        />
      </Form.Group>
    </Form>

    <div className="d-grid gap-2">
      <Button
        variant="primary"
        className="rounded-pill fw-semibold py-2"
        onClick={handleSendNotification}
      >
        <i className="fas fa-paper-plane me-2"></i>Send Notification
      </Button>
      <Button
        variant="light"
        className="rounded-pill border fw-semibold py-2"
        onClick={() => setShowModal(false)}
      >
        Cancel
      </Button>
    </div>
  </Modal.Body>
</Modal>

      {/* Settings Modal */}
      <Modal
        show={showSettingsModal}
        onHide={() => setShowSettingsModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> Shelters Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GlobalShelterSettings />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSettingsModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toasts */}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowAlert(false)}
          show={showAlert}
          delay={3000}
          autohide
          bg={alertVariant || "success"}
        >
          <Toast.Body className="text-white">{alertMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Layout>
  );
};

export default Dashboard;
